import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const barcodeSettingsRoutes = [
    {
        path: '/Settings/Barcode',
        component: React.lazy(() => import('./BarcodeSettingsPage')),
        auth: authRoles.admin,
        accessPageName: 'SETTINGS',
    },
]

export default barcodeSettingsRoutes
